/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from 'react';
import { ThemeProvider } from 'react-jss';

import theme from '../../theme';
import Header from './Header';
import Footer from './Footer';
import BaseCss from './BaseCss';
import { ConsentProvider } from './Tracking/ConsentContext';
import TrackingScripts from './Tracking/TrackingScripts';
import ConsentBanner from './Tracking/ConsentBanner';
import Plausible from 'plausible-tracker';
import FontLoader from './FontLoader';
import { ISiteBanner } from 'types';

interface IProps {
  includeSiteBanner?: boolean;
  siteBanner?: ISiteBanner | null;
  type?: string;
}

const Page: React.FunctionComponent<IProps> = ({ children, includeSiteBanner = false, siteBanner, type }) => {
  useEffect(() => {
    // window.plausible = Plausible({
    //   domain: 'edgeimpulse.com',
    //   apiHost: 'https://explicatio.edgeimpulse.com'
    //   // trackLocalhost: true
    // });
    // window.plausible.trackPageview(
    //   {},
    //   {
    //     callback: () => {
    //       return;
    //     }
    //   }
    // );
  }, []);

  let body = <main>{children}</main>;
  if (type === 'blog') {
    body = (
      <main itemScope itemProp="mainEntity" itemType="http://schema.org/Blog">
        {children}
      </main>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <ConsentProvider>
        <TrackingScripts />
        <BaseCss />
        <FontLoader />
        <Header includeSiteBanner={includeSiteBanner} siteBanner={siteBanner || null} />
        {body}
        <Footer />
      </ConsentProvider>
    </ThemeProvider>
  );
};

export default Page;
